import { OrderStatusEnum } from "@src/features/order/entities";
import { IOrderInitialState } from "./types";

const initialState: IOrderInitialState = {
  selectedOrder: null,
  orderFormData: null,
  assignedDrone: null,
  assignMethod: 'auto',
  missionId: null,
  selectedMissionTemplate: null,
  collapse: {
    [OrderStatusEnum.NEW]: true,
    [OrderStatusEnum.ASSIGNED]: true,
    [OrderStatusEnum.READY_FOR_TAKE_OFF]: true,
    [OrderStatusEnum.EN_ROUTE]: true,
    [OrderStatusEnum.COMPLETED]: true,
    [OrderStatusEnum.CANCELLED]: true,
    [OrderStatusEnum.ERROR]: true, 
    [OrderStatusEnum.IN_FLIGHT]: true,
  }
};

export default initialState;